import React, { use, useCallback, useEffect, useState } from "react";
import {
    Card, CardBody, Col, Container, Input, Label, Row, Modal
    , ModalBody, ModalHeader
} from "reactstrap";
import BreadCrumb from "../common/BreadCrumb.tsx";
import { ToastContainer, toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import logoLarge from '../../Assets/user-dummy-img.jpg'
import CreateProvider from "./CreateProvider.tsx";
import UserDetails from "./UserDetails.tsx";
import { auth } from "../../Services/LoginService.ts";

export default function UserProfile() {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [user, setUser] = useState(null);
    const [update, setUpdate] = useState(false);
    const [editData, setEditData] = useState({})
    const changePassword = location?.state?.changePassword || true;
    const [changePasswordStatus, setChangePasswordStatus] = useState(false);
    const userId = localStorage.getItem('userId');
    const userName = localStorage.getItem('userName')
    const isProfile = location.pathname.includes('profile')
    const isCustomerProfile = location.pathname.includes('/customer/profile')

    let base64ImageData = [];
    const initialValues = {
        firstname: "",
        lastname: "",
        usernames: "",
        userrole: "",
        phone: "",
        email: "",
        status: ""
    };
    const [profileImage, setProfileImage] = useState(logoLarge);
    const [fileSelected, setFileSelected] = useState(false);
    const [profileData, setProfileData] = useState(false);
    // const roleName = localStorage.getItem("roleName")
    const [file, currentSelectedFile] = useState(null)
    const [dialCode, setDialCode] = useState()
    const [subscriptionId, setSubscriptionId] = useState()
    const [stateData, setStatedata] = useState();
    const [cityData, setCityData] = useState()
    const [selectedCountry, setSelectedCountry] = useState()
    const [stateOptions, setStateOptions] = useState()
    const [selectedState, setSelectedState] = useState()
    const [callState, setCallState] = useState(false)
    const [callCity, setCallCity] = useState(false)
    let optionState = []
    const profileuser = location.pathname.includes('profile-user')
    const [isEditButton, setIsEditButton] = useState(false);
    const toggleEditModal = () => {
        setIsEdit(!isEdit)
    }
    const toggleChangePasswordModal = () => {
        setChangePasswordStatus(!changePasswordStatus)
    }

    useEffect(() => {
        const getUser = async () => {
            try {
                const response = await auth.getUser();
                setUser(response?.data);
                setEditData(response?.data);
            } catch (error) {
                console.error("Error fetching datasource configuration:", error);
                setUser(null);
                setEditData(null);
            }
        };
        getUser();
    }, []);
    // useEffect(() => {
    //     if (user?.role === "systemUser") {
    //         let partnerOrCustomer = "User"
    //         dispatch(systemUserLogoViewDoc(setLoading, userId, "logo", partnerOrCustomer, setProfileData));
    //     }
    //     if (((user && user?.userDetails?.userName) || (user?.role === "Customer" && customerId)) && user?.role !== "systemUser") {
    //         const partnerOrCustomer = user?.role === "Customer" ? "Customer" : "User";
    //         dispatch(ProfilelogoDoc(setLoading, user?.role === "Customer" ? customerId : userId, "logo", partnerOrCustomer, setProfileData));
    //     }
    // }, [dispatch, user, userId]);

    // const ViewDocument = useSelector((state) => state.ProfileLogo.profileLogo);
    // let profile = useSelector((state) => state.ViewDocument.documentView)

    // let systemUserProfile = useSelector((state) => state.SystemLogoView.logoView)
    // if (roleName === "systemUser") {
    //     base64ImageData = systemUserProfile?.filePath;
    // } else {
    //     base64ImageData = ViewDocument?.filePath;
    // }

    // useEffect(() => {
    //     if (roleName === "systemUser") {
    //         if (systemUserProfile) {
    //             setProfileImage(systemUserProfile?.filePath);
    //         }
    //     }
    //     else if (roleName === "ISPPartnerAdmin") {
    //         if (profile) {
    //             setProfileImage(profile?.filePath)
    //         }
    //     }
    //     else {
    //         if (base64ImageData) {
    //             setProfileImage(base64ImageData);
    //         }
    //     }
    // }, [base64ImageData, systemUserProfile]);

    const documentJson = useCallback((file) => {
        const formData = new FormData();
        if (user?.userDetails || (user?.role === "Customer" && customerId)) {
            formData.append("ID", user?.role === "Customer" ? customerId : user.userDetails.userId);
            formData.append("file", file);
            if (user?.role === "systemUser") {
                formData.append("userType", "operator")
            }
            formData.append("documentName", "logo");
            formData.append("documentType", "logo");
            formData.append('uploadedBy', user?.role === "Customer" ? userName : user.userDetails.userName);
        } else {
            console.error('User details not available');
        }
        return formData;
    }, [user]);

    const UpdateJson = useCallback((file) => {
        const formData = new FormData();
        if (user?.userDetails || (user?.role === "Customer" && customerId)) {
            formData.append("ID", user?.role === "Customer" ? customerId : user.userDetails.userId);
            formData.append("file", file);
            if (user?.role === "systemUser") {
                formData.append("userType", "operator")
            }
            formData.append("documentName", "logo");
            formData.append("documentType", "logo");
            formData.append("newDocumentName", "logo");
            formData.append('uploadedBy', user?.role === "Customer" ? userName : user.userDetails.userName);
        } else {
            console.error('User details not available');
        }
        return formData;
    }, [user]);

    // const uploadDocApiCall = useCallback((file) => {
    //     if (user?.userDetails || (roleName === "Customer" && customerId)) {
    //         const partnerOrCustomer = roleName === "Customer" ? "Customer" : "User";
    //         if (base64ImageData) {
    //             const updateObj = UpdateJson(file);
    //             dispatch(documentUpdateFile(setLoading, updateObj, roleName === "Customer" ? customerId : userId, "logo", partnerOrCustomer, setUpdate, setFileSelected, navigate, setProfileData));
    //         } else {
    //             const documentObj = documentJson(file);
    //             dispatch(partnerUploadDocument(documentObj, setLoading, roleName === "Customer" ? customerId : userId, "logo", partnerOrCustomer, setFileSelected, navigate, setProfileData));
    //         }
    //     } else {
    //         console.error('User details not available for upload');
    //     }
    // }, [dispatch, documentJson, UpdateJson, customerId, fetchCustomerData, userId, user, base64ImageData]);

    // const handleImageUpload = (file) => {
    //     if (file) {
    //         setFileSelected(true);
    //         const reader = new FileReader();
    //         reader.onload = (e) => {
    //             setProfileImage(e.target.result);
    //         };
    //         reader.readAsDataURL(file);
    //         uploadDocApiCall(file);
    //     }
    // };

    // const showEditSuccessMessage = useSelector((state) => state.SuccessToast.showEditSuccessMessage);
    // const showEmailUpdateSuccessMessage = useSelector((state) => state.SuccessToast.showEmailUpdateSuccessMessage)
    // useEffect(() => {
    //     if (isCustomerProfile) {
    //         if (showEditSuccessMessage) {
    //             toast.success(`User Updated Successfully`);
    //             dispatch(setEditSuccessMessage(false));
    //         }
    //         if (showEmailUpdateSuccessMessage) {
    //             toast.success(`Verification link has been sent to your updated email`);
    //             dispatch(setEmailUpdateSuccessMessage(false));
    //         }
    //     }
    // }, [isCustomerProfile, showEditSuccessMessage, showEmailUpdateSuccessMessage, dispatch])


    const initialFormValues = {
        accountNumber: '',
        firstName: '',
        lastName: '',
        email: '',
        mobile: '',
        addressLine1: '',
        addressLine2: '',
        country: '',
        state: '',
        city: '',
        zipCode: '',
        dialCode: '',
        subscriptions: [],
        attributeList: []
    }
    // const countries = useSelector(state => state.Countries.countries)
    // const countryOptions = countryOptionss(countries?.countries)
    // const profileOptions = [
    //     {
    //         name: "country",
    //         value: "Profile",
    //         options: countryOptions
    //     }
    // ]
    return (
        <React.Fragment>
            {/* <div id='csms' className='page-content bg-white'> */}
                <Container fluid>
                    <BreadCrumb moduleName={"Profile"} />
                    <ToastContainer position='top-center' />
                    <h5 class="rv-page-title p-2">View Profile</h5>
                    <div className="d-flex justify-content-center my-5">
                        <Row className="flex-grow-1" style={{ maxWidth: "80%" }}>
                            <Col lg={12}>
                                <div className="d-flex justify-content-between flex-wrap flex-column flex-md-row">
                                    <div className="d-flex align-items-center mb-3 mb-md-0">
                                        <img
                                            src={profileImage}
                                            className="rounded-circle avatar-xl img-thumbnail user-profile-image w-h-130"
                                            onError={(e) => {
                                                e.target.onerror = null;
                                                e.target.src = logoLarge
                                            }}
                                            alt="user-profile"
                                        />
                                        <h5 className="text-black ms-2 fw-bold align-self-center">
                                            {user?.profile?.firstName} {user?.profile?.lastName}
                                        </h5>

                                    </div>
                                    <div class="d-md-block d-flex gap-2 flex-grow-1 flex-grow-md-0 text-center text-md-end">
                                        {/* {profilePermission && profilePermission?.has("update") && (<button
                                            type="button"
                                            onClick={() => {
                                                toggleEditModal()
                                            }}
                                            class="btn-label rv-primary-btn me-2  px-4 py-1 text-nowrap btn btn-secondary"
                                        >
                                            <i class="ri-edit-box-line label-icon align-middle fs-16 me-1"></i>
                                            <span class="ps-3 ms-2 me-1">Edit</span>
                                        </button>)} */}
                                         {/* {profilePermission && profilePermission?.has("changepassword")  &&
                                        <button
                                            type="button"
                                            onClick={() => {
                                                setChangePasswordStatus((prev)=>!prev)
                                            }}
                                            class="btn-label rv-primary-btn me-2  px-4 py-1 text-nowrap btn btn-secondary"
                                        >
                                            <i class="ri-lock-fill label-icon align-middle fs-16 me-1"></i>
                                            <span class="ps-3 ms-2 me-1">Change Password</span>
                                        </button>} */}
                                    </div>
                                </div>
                            </Col>
                            <Col lg={12}>
                                <UserDetails user={user}>
                                </UserDetails>
                            </Col>
                        </Row>

                        <Modal isOpen={isEdit} toggle={toggleEditModal} centered={true} className="custom-modal-width-850 editBussinessProfileModal">
                            <ModalHeader
                                className="d-flex justify-content-center align-items-center rv-breadcrumb-border p-3"
                                fade={false}
                            >
                                <div className="w-100 text-center">
                                    Edit Profile
                                </div>
                                <button type="button" className="close-button-currency mt-n1 fs-1 align-self-center" onClick={toggleEditModal}>
                                    &times;
                                </button>
                            </ModalHeader>
                            <ModalBody>
                                {/* <CreateProvider setIsEdit={setIsEdit} customerPermission={customerPermission} roleName={roleName} profilePermission={profilePermission} isEdit={isEdit} isProfile={isProfile} currentSelectedFile={currentSelectedFile} setDialCode={setDialCode} customerId={customerId} dialCode={dialCode} setSelectedState={setSelectedState} stateData={stateData} cityData={cityData} setSelectedCountry={setSelectedCountry} profileOptions={profileOptions} fetchCustomerData={fetchCustomerData} user={user} userId={userId} navigate={navigate} dispatch={dispatch} setLoading={setLoading} changePassword={changePassword} profile={profileuser} setChangePasswordStatus={setChangePasswordStatus} initialValues={initialFormValues} initialFormValues={initialFormValues} handleImageUpload={handleImageUpload}/> */}
                            </ModalBody>
                        </Modal>
                        <Modal isOpen={changePasswordStatus} toggle={toggleChangePasswordModal} centered={true} className="editBussinessProfileModal">
                            <ModalHeader
                                className="d-flex justify-content-center align-items-center rv-breadcrumb-border p-3"
                                fade={false}
                            >
                                <div className="w-100 text-center">
                                    Change Password
                                </div>
                                <button type="button" className="close-button-currency mt-n1 fs-1 align-self-center" onClick={toggleChangePasswordModal}>
                                    &times;
                                </button>
                            </ModalHeader>
                            <ModalBody>
                                {/* <CreateProvider isChangePasswordModal={true} setIsEdit={setIsEdit} customerPermission={customerPermission} roleName={roleName} profilePermission={profilePermission} isEdit={isEdit} isProfile={isProfile} currentSelectedFile={currentSelectedFile} setDialCode={setDialCode} customerId={customerId} dialCode={dialCode} setSelectedState={setSelectedState} stateData={stateData} cityData={cityData} setSelectedCountry={setSelectedCountry} profileOptions={profileOptions} fetchCustomerData={fetchCustomerData} user={user} userId={userId} navigate={navigate} dispatch={dispatch} setLoading={setLoading} changePassword={changePassword} profile={profileuser} setChangePasswordStatus={setChangePasswordStatus} initialValues={initialFormValues} initialFormValues={initialFormValues} handleImageUpload={handleImageUpload}/> */}
                            </ModalBody>
                        </Modal>
                    </div>
                </Container>
                {/* {loading && <Loader />} */}
            {/* </div> */}
        </React.Fragment>
    );
}
